module.exports = "<div class=\"client-header flex-row\">\n    <div class=\"col-sm-12 navbar-header flex-row flex-align-center flex-just-space\">\n        <a class=\"navbar-brand flex-row flex-align-center navbar-center\">\n            <img class=\"company-image\" ng-show=\"companyImage\" alt=\"Company image\" src=\"{{companyImage}}\"/>\n        </a>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./web/js/components/navigation/subscriptionNavbar.component.html
// module id = ./web/js/components/navigation/subscriptionNavbar.component.html
// module chunks = 0